// src/pages/DuyurularPage.js
import ResimUpload from "../ResimUpload";
import GlobalStyles from "@mui/material/GlobalStyles";
import { API_BASE, UPLOAD_BASE, ORIGIN_BASE } from '../config';


import React, { useMemo, useState, useEffect } from "react";
import {
  List,
  Datagrid,
  BooleanField,
  Edit,
  Create,
  EditButton,
  SimpleForm,
  TextInput,
  DateInput,
  BooleanInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  useRecordContext,
  useRefresh,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  ImageField,
  TextField,
  SelectInput,
  EditBase,
  useEditContext,
  useUpdate,
  FunctionField,              // 👈 tarih için
} from "react-admin";
import { useWatch, useFormContext } from "react-hook-form";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  AddCircle as AddCircleIcon,
  FileDownload as FileDownloadIcon,
} from "@mui/icons-material";

const PLACEHOLDER = "Bu dilde içerik mevcut değildir.";
const ALLOWED = ["tr", "en", "de"];

/* --- UI TEXTS --- */
const T = {
  tr: {
    listTitle: "📅 Etkinlikler",
    newBtn: "Yeni Etkinlik",
    exportBtn: "Dışa Aktar",
    save: "Kaydet",
    saving: "Kaydediliyor…",
    cancel: "Vazgeç",
    editTitle: "Etkinlik Düzenle",
    updatedOk: "✅ Güncelleme başarılı",
    uploadImage: "Görsel Yükle",

    image: "Resim",
    title: "Başlık",
    previousCol: "Önceki",
    previousTitle: "Daha önceki etkinlik başlığı",
    link: "Link",
    status: "Durum",
    contentLang: "İçerik Dili",
    edit: "Düzenle",
    delete: "Sil",
    confirmDelete: "Silmek istediğinize emin misiniz?",
    createTitle: "➕ Yeni Etkinlik Ekle",
    createdOk: "✅ Etkinlik başarıyla oluşturuldu",
    linkLbl: "🔗 Link (https://...)",
    imageUrl: "🖼️ Görsel URL",
    langField: "🌐 İçerik Dili (tr/en/de)",
    date: "📅 Tarih",
    activeQ: "✅ Aktif mi?",
    trTitle: "🇹🇷 Başlık (Türkçe)",
    enTitle: "🇬🇧 Title (İngilizce)",
    deTitle: "🇩🇪 Titel (Almanca)",
    trDesc: "🇹🇷 Açıklama (Türkçe)",
    enDesc: "🇬🇧 Description (İngilizce)",
    deDesc: "🇩🇪 Beschreibung (Almanca)",
    emptyTitle: "Slaytlar için etkinlik eklemeye hoş geldiniz",
    emptyDesc:
      "Buraya ekleyeceğiniz görseller ve metinler ana sayfanızdaki slayt bölümünde yayınlanacaktır.",
    emptyBtn: "Hemen Etkinlik Ekle",
    langNames: { tr: "Türkçe", en: "İngilizce", de: "Almanca" },
    changeImage: "Değiştir",
    contentLangShort: "İçerik Dili",
    active: "Aktif",
    passive: "Pasif",
  },
  en: {
    listTitle: "📢 Announcements",
    newBtn: "New Announcement",
    exportBtn: "Export",
    image: "Image",
    title: "Title",
    previousCol: "Previous",
    previousTitle: "Previous event title",

    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    editTitle: "Edit Announcement",
    updatedOk: "✅ Update successful",
    uploadImage: "Upload Image",

    link: "Link",
    status: "Status",
    contentLang: "Content Language",
    edit: "Edit",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete?",
    createTitle: "➕ Create Announcement",
    createdOk: "✅ Announcement created",
    linkLbl: "🔗 Link (https://...)",
    imageUrl: "🖼️ Image URL",
    langField: "🌐 Content Language (tr/en/de)",
    date: "📅 Date",
    activeQ: "✅ Active?",
    trTitle: "🇹🇷 Title (Turkish)",
    enTitle: "🇬🇧 Title (English)",
    deTitle: "🇩🇪 Title (German)",
    trDesc: "🇹🇷 Description (Turkish)",
    enDesc: "🇬🇧 Description (English)",
    deDesc: "🇩🇪 Description (German)",
    emptyTitle: "Welcome to your homepage slider",
    emptyDesc:
      "Items you add here will appear in the slider section of your homepage.",
    emptyBtn: "Add Announcement",
    langNames: { tr: "Turkish", en: "English", de: "German" },
    changeImage: "Change",
    contentLangShort: "Content Language",
    active: "Active",
    passive: "Inactive",
  },
  de: {
    listTitle: "📢 Mitteilungen",
    newBtn: "Neue Mitteilung",
    exportBtn: "Exportieren",
    image: "Bild",
    title: "Titel",
    previousCol: "Frühere",
    previousTitle: "Titel der früheren Veranstaltung",

    save: "Speichern",
    saving: "Wird gespeichert…",
    cancel: "Abbrechen",
    editTitle: "Mitteilung bearbeiten",
    updatedOk: "✅ Erfolgreich aktualisiert",
    uploadImage: "Bild hochladen",

    link: "Link",
    status: "Status",
    contentLang: "Inhaltssprache",
    edit: "Bearbeiten",
    delete: "Löschen",
    confirmDelete: "Möchten Sie wirklich löschen?",
    createTitle: "➕ Mitteilung erstellen",
    createdOk: "✅ Mitteilung erstellt",
    linkLbl: "🔗 Link (https://...)",
    imageUrl: "🖼️ Bild-URL",
    langField: "🌐 Inhaltssprache (tr/en/de)",
    date: "📅 Datum",
    activeQ: "✅ Aktiv?",
    trTitle: "🇹🇷 Titel (Türkisch)",
    enTitle: "🇬🇧 Titel (Englisch)",
    deTitle: "🇩🇪 Titel (Deutsch)",
    trDesc: "🇹🇷 Beschreibung (Türkisch)",
    enDesc: "🇬🇧 Beschreibung (Englisch)",
    deDesc: "🇩🇪 Beschreibung (Deutsch)",
    emptyTitle: "Willkommen zum Startseiten-Slider",
    emptyDesc:
      "Hier hinzugefügte Elemente erscheinen im Slider-Bereich Ihrer Startseite.",
    emptyBtn: "Mitteilung hinzufügen",
    langNames: { tr: "Türkisch", en: "Englisch", de: "Deutsch" },
    changeImage: "Ändern",
    contentLangShort: "Inhaltssprache",
    active: "Aktiv",
    passive: "Inaktiv",
  },
};

function useUiTexts() {
  const [uiLang, setUiLang] = useState(
    () => (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase()
  );
  useEffect(() => {
    const sync = () => {
      const l = (localStorage.getItem("app_lang") || "tr")
        .slice(0, 2)
        .toLowerCase();
      setUiLang(ALLOWED.includes(l) ? l : "tr");
    };
    window.addEventListener("app_lang_change", sync);
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("app_lang_change", sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);
  return useMemo(() => T[ALLOWED.includes(uiLang) ? uiLang : "tr"], [uiLang]);
}

/* ---------- Actions bar ---------- */
const ListActions = () => {
  const TT = useUiTexts();
  return (
    <TopToolbar
      sx={{ gap: 1.5, px: 0, width: "100%", justifyContent: "flex-end" }}
    >
      <CreateButton
        icon={<AddCircleIcon />}
        label={TT.newBtn}
        sx={{
          px: 3,
          py: 1.35,
          fontSize: "1.05rem",
          fontWeight: 800,
          borderRadius: "6px",
          textTransform: "none",
          letterSpacing: "0.2px",
          bgcolor: "#f59e0b !important",
          color: "#fff !important",
          boxShadow: "0 6px 18px rgba(245,158,11,0.28)",
          "&:hover": { bgcolor: "#d97706 !important" },
        }}
      />
      <ExportButton
        icon={<FileDownloadIcon />}
        label={TT.exportBtn}
        sx={{
          px: 2.25,
          py: 1.1,
          fontSize: "1rem",
          fontWeight: 700,
          borderRadius: "6px",
          textTransform: "none",
          letterSpacing: "0.2px",
          bgcolor: "#2563eb !important",
          color: "#fff !important",
          boxShadow: "0 6px 18px rgba(37,99,235,0.22)",
          "&:hover": { bgcolor: "#1d4ed8 !important" },
        }}
      />
    </TopToolbar>
  );
};

/* ---------- Delete button ---------- */
const CustomDeleteButton = ({ record }) => {
  const TT = useUiTexts();
  const refresh = useRefresh();

  const handleDelete = async () => {
    const confirmed = window.confirm(TT.confirmDelete);
    if (!confirmed) return;
    const token = localStorage.getItem("token");
  await fetch(`${API_BASE}/etkinlikler/${record.id}`, {
  method: "DELETE",
  headers: { Authorization: `Bearer ${token}` },
});

    refresh();
  };

return (
  <button
    onClick={handleDelete}
    title={TT.delete}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "4px",
      maxWidth: 90,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      padding: "6px 8px",
      fontSize: "0.8rem",
      fontWeight: 800,
      color: "#fff",
      background: "#ef4444",
      border: "1px solid #ef4444",
      borderRadius: 6,
      cursor: "pointer",
    }}
  >
    <DeleteIcon fontSize="small" />
    <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
      {TT.delete}
    </span>
  </button>
);
};

const ActionButtons = () => {
  const TT = useUiTexts();
  const record = useRecordContext();

  return (
    <div
      style={{
        display: "flex",
        gap: "6px",
        flexWrap: "nowrap",
        whiteSpace: "nowrap",
        overflow: "hidden",
      }}
    >
      <EditButton
        record={record}
        icon={<EditIcon />}
        label={TT.edit}
        sx={{
          minWidth: 0,
          px: 1,
          py: 0.5,
          fontSize: "0.8rem",
          fontWeight: 800,
          textTransform: "none",
          whiteSpace: "nowrap",
          color: "#fff !important",
          bgcolor: "#f59e0b !important",
          borderRadius: "6px",
          "& .MuiButton-startIcon": { mr: "4px" },
        }}
      />
      <CustomDeleteButton record={record} />
    </div>
  );
};


/* ---------- Title cell (smart) ---------- */
const BaslikField = ({ label }) => {
  const record = useRecordContext();
  if (!record) return null;

  const pickValue = (code) =>
    code === "tr"
      ? record.baslik_tr
      : code === "en"
      ? record.baslik_en
      : record.baslik_de;

  const langOrder = [record.dil, "tr", "en", "de"].filter(Boolean);
  let value = "-";
  for (const code of langOrder) {
    const v = pickValue(code);
    if (v && v.trim() && v.trim() !== PLACEHOLDER) {
      value = v;
      break;
    }
  }

  return (
    <span
      style={{
        fontWeight: 800,
        fontSize: "1.02rem",
        color: "#0f172a",
        display: "block",
      }}
      aria-label={label}
      title={value}
    >
      {value}
    </span>
  );
};

/* ---------- Previous (lang-aware) ---------- */
const OncekiField = ({ label }) => {
  const r = useRecordContext();
  if (!r) return null;

  const pickValue = (code) =>
    code === "tr" ? r.onceki_tr : code === "en" ? r.onceki_en : r.onceki_de;

  const langOrder = [r.dil, "tr", "en", "de"].filter(Boolean);
  let value = "-";
  for (const code of langOrder) {
    const v = pickValue(code);
    if (v && v.trim() && v.trim() !== PLACEHOLDER) {
      value = v;
      break;
    }
  }

  return (
    <span
      style={{
        fontWeight: 700,
        fontSize: "0.98rem",
        color: "#334155",
        display: "block",
      }}
      aria-label={label}
      title={value}
    >
      {value}
    </span>
  );
};

/* ---------- Language cell ---------- */
const DilField = ({ label, names }) => {
  const record = useRecordContext();
  if (!record) return null;

  let code = record.dil;
  if (!code) {
    if (record.baslik_tr && record.baslik_tr !== PLACEHOLDER) code = "tr";
    else if (record.baslik_en && record.baslik_en !== PLACEHOLDER) code = "en";
    else if (record.baslik_de && record.baslik_de !== PLACEHOLDER) code = "de";
  }
  const labelText = names[code] || "-";
  return (
    <span
      aria-label={label}
      title={labelText}
      style={{ fontWeight: 700, fontSize: "0.95rem", color: "#334155" }}
    >
      {labelText}
    </span>
  );
};

/* ---------- Empty State ---------- */
const EmptyState = () => {
  const TT = useUiTexts();
  return (
    <div
      style={{
        width: "100%",
        minHeight: "50vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: 680, padding: "32px 16px" }}>
        <div
          style={{
            width: 88,
            height: 88,
            borderRadius: 14,
            border: "2px dashed #cbd5e1",
            margin: "0 auto 14px",
            display: "grid",
            placeItems: "center",
            fontSize: 36,
            color: "#94a3b8",
          }}
        >
          🖼️
        </div>
        <h2 style={{ fontSize: 26, fontWeight: 900, margin: 0, color: "#0f172a" }}>
          {TT.emptyTitle}
        </h2>
        <p style={{ fontSize: 16, color: "#475569", marginTop: 10 }}>
          {TT.emptyDesc}
        </p>
        <CreateButton
          label={TT.emptyBtn}
          icon={<AddCircleIcon />}
          sx={{
            mt: 2,
            px: 3,
            py: 1.35,
            fontSize: "1.05rem",
            fontWeight: 800,
            borderRadius: "6px",
            textTransform: "none",
            bgcolor: "#f59e0b !important",
            color: "#fff !important",
            "&:hover": { bgcolor: "#d97706 !important" },
          }}
        />
      </div>
    </div>
  );
};

/* =================== LIST =================== */
export const EtkinliklerPage = (props) => {
  const TT = useUiTexts();
  return (
    <>
      {/* Bildirimleri büyüt */}
      <GlobalStyles
        styles={{
          ".MuiSnackbarContent-message": { fontSize: "1.05rem", fontWeight: 800 },
          ".RaNotification-content": { fontSize: "1.05rem", fontWeight: 800 },
        }}
      />
      <List
        {...props}
        title={TT.listTitle}
        actions={<ListActions />}
        sort={{ field: "tarih", order: "DESC" }}
        empty={<EmptyState />}
        sx={{
  width: "100%",
  tableLayout: "fixed",

  "& .RaDatagrid-headerCell": {
    fontWeight: 900,
    fontSize: "1rem",
    color: "#0f172a",
    py: 1,
  },

  "& .RaDatagrid-row": {
    py: 0.75,
    "&:hover": { backgroundColor: "#f8fafc" },
  },

  "& .MuiTableCell-root": {
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingLeft: "12px",
    paddingRight: "12px",
    verticalAlign: "middle",
  },

  "& .column-resim": {
    width: 100,
    minWidth: 150,
    maxWidth: 100,
    paddingRight: "15px",
  },
  "& .column-baslik": { width: "22%" },
  "& .column-onceki": { width: "22%" },
  "& .column-link": { width: "26%" },
  "& .column-tarih": { width: 120, minWidth: 120 },
  "& .column-aktif": { width: 90, minWidth: 90 },
  "& .column-lang": { width: 110, minWidth: 110 },
"& .column-actions": {
  width: "auto",
  minWidth: 160,
  whiteSpace: "nowrap",
},


  /* 🔥 BURASI YENİ: FAALİYETLERDEKİ MOBİL UYUM BLOĞU 🔥 */
  "@media (max-width: 900px)": {
    display: "block",

    "& .RaDatagrid-table": {
      width: "100%",
      display: "block",
    },

    "& .RaDatagrid-thead": {
      display: "none",
    },

    "& .RaDatagrid-tbody": {
      display: "grid",
      gap: "12px",
      padding: "10px",
    },

    "& .RaDatagrid-row": {
      display: "grid",
      background: "#ffffff",
      borderRadius: "8px",
      padding: "12px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    },

    "& .MuiTableCell-root": {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      padding: "8px 0 !important",
      borderBottom: "1px solid #f1f5f9",
      fontSize: "0.9rem !important",
      whiteSpace: "normal",
    },

    "& .column-actions": {
      justifyContent: "flex-start",
      borderBottom: "none",
      paddingTop: "10px",
    }
  },
}}
>




 <Datagrid
  rowClick={false}
  bulkActionButtons={false}
  isRowSelectable={() => false}
  sx={{
   "& .RaDatagrid-headerCell.RaDatagrid-checkbox": { display: "none" },
"& .RaDatagrid-rowCell.RaDatagrid-checkbox": { display: "none" },
  }}
>

  <ImageField
    source="resim"
    label={TT.image}
    className="column-resim"
    sx={{
      "& img": {
        width: 48,
        height: 48,
        objectFit: "cover",
        borderRadius: 6,
        border: "1px solid #e5e7eb",
      },
    }}
  />

  <BaslikField label={TT.title} className="column-baslik" />
  <OncekiField label={TT.previousCol} className="column-onceki" />

  <TextField
    source="link"
    label={TT.link}
    className="column-link"
    sx={{
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontSize: "0.95rem",
      color: "#0f172a",
    }}
  />

  <FunctionField
    label={TT.date}
    className="column-tarih"
    render={(r) => (r?.tarih ? String(r.tarih).slice(0, 10) : "-")}
  />

  <FunctionField
    label={TT.status}
    className="column-aktif"
    render={(r) => (r.aktif ? "Aktif" : "Pasif")}
    sx={{ fontWeight: 700 }}
  />

  <DilField label={TT.contentLang} names={TT.langNames} className="column-lang" />

<div
  className="column-actions"
  style={{
    display: "flex",
    justifyContent: "flex-end",
    whiteSpace: "nowrap",
  }}
>
  <ActionButtons />
</div>

</Datagrid>


      </List>
    </>
  );
};

/* ===== Dil-uyumlu input grubu (Create için) ===== */
const LangAwareInputs = ({ TT }) => {
  const dil = (useWatch({ name: "dil" }) || "tr").toLowerCase();
  const show = (code) => (dil === code ? "block" : "none");

  return (
    <>
      {/* TR */}
      <div style={{ display: show("tr") }}>
        <TextInput source="baslik_tr" label={TT.trTitle} fullWidth />
        <TextInput
          source="aciklama_tr"
          label={TT.trDesc}
          fullWidth
          multiline
          minRows={4}
        />
      </div>

      {/* EN */}
      <div style={{ display: show("en") }}>
        <TextInput source="baslik_en" label={TT.enTitle} fullWidth />
        <TextInput
          source="aciklama_en"
          label={TT.enDesc}
          fullWidth
          multiline
          minRows={4}
        />
      </div>

      {/* DE */}
      <div style={{ display: show("de") }}>
        <TextInput source="baslik_de" label={TT.deTitle} fullWidth />
        <TextInput
          source="aciklama_de"
          label={TT.deDesc}
          fullWidth
          multiline
          minRows={4}
        />
      </div>
    </>
  );
};

/* ====== Başlık tek alan (Create için) ====== */
const TitleByDil = ({ TT }) => {
  const dil = (useWatch({ name: "dil" }) || "tr").toLowerCase();
  const source = dil === "en" ? "baslik_en" : dil === "de" ? "baslik_de" : "baslik_tr";
  return <TextInput source={source} label={TT.title} fullWidth />;
};

/* ====== Açıklama tek alan (Create için) ====== */
const DescByDil = ({ TT }) => {
  const dil = (useWatch({ name: "dil" }) || "tr").toLowerCase();
  const source = dil === "en" ? "aciklama_en" : dil === "de" ? "aciklama_de" : "aciklama_tr";
  return (
    <TextInput
      source={source}
      label={TT.trDesc.replace("🇹🇷 ", "").replace(" (Türkçe)", "")}
      fullWidth
      multiline
      minRows={4}
    />
  );
};

/* ====== Resim alanı + upload (Create için) ====== */
const ResimRow = ({ TT }) => {
  const { setValue } = useFormContext();
  const rawUrl = useWatch({ name: "resim" }) || "";
  const [ver, setVer] = React.useState(0);
  const previewUrl = rawUrl ? `${rawUrl}${rawUrl.includes("?") ? "&" : "?"}v=${ver}` : "";

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "96px 1fr",
        gap: 12,
        alignItems: "center",
      }}
    >
      <div>
        {rawUrl ? (
          <img
            key={previewUrl}
            src={previewUrl}
            alt="preview"
            style={{
              width: 88,
              height: 88,
              objectFit: "cover",
              borderRadius: 10,
              border: "1px solid #e5e7eb",
            }}
          />
        ) : (
          <div
            style={{
              width: 88,
              height: 88,
              borderRadius: 10,
              border: "1px dashed #cbd5e1",
              display: "grid",
              placeItems: "center",
              color: "#94a3b8",
              fontSize: 20,
            }}
          >
            🖼️
          </div>
        )}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8 }}>
        <TextInput source="resim" label={TT.imageUrl} fullWidth />
        <ResimUpload
          onUpload={(url) => {
            setValue("resim", url, { shouldDirty: true, shouldTouch: true });
            setVer((n) => n + 1);
          }}
        />
      </div>
    </div>
  );
};

/* ---------- UPDATE Normalizer (kalsın) ---------- */
function normalizeUpdate(data, previousData) {
  const merged = { ...previousData, ...data };
  const dil = (merged.dil || "tr").toLowerCase();
  merged.dil = ALLOWED.includes(dil) ? dil : "tr";
  if (typeof merged.aktif === "string") {
    merged.aktif = merged.aktif === "true" || merged.aktif === "1";
  } else {
    merged.aktif = !!merged.aktif;
  }
  if (merged.tarih) {
    const d = new Date(merged.tarih);
    if (!isNaN(d.getTime())) {
      merged.tarih = d.toISOString().slice(0, 10);
    }
  }
  if (merged.resim == null) merged.resim = "";
  const titleKey = dil === "en" ? "baslik_en" : dil === "de" ? "baslik_de" : "baslik_tr";
  const descKey = dil === "en" ? "aciklama_en" : dil === "de" ? "aciklama_de" : "aciklama_tr";
  merged[titleKey] = merged[titleKey] ?? previousData?.[titleKey] ?? "";
  merged[descKey] = merged[descKey] ?? previousData?.[descKey] ?? "";
  ["baslik_tr","baslik_en","baslik_de","aciklama_tr","aciklama_en","aciklama_de"].forEach(k=>{
    if (merged[k] === PLACEHOLDER) merged[k] = "";
  });
  return merged;
}

/* =================== EDIT (full-width, iki sütun) =================== */
export const EtkinlikEdit = (props) => (
  <EditBase resource="etkinlikler" {...props}>
    <EtkinlikEditView />
  </EditBase>
);

/* Kayıtta dil belli değilse içerik olan dili seç */
function detectPreferredLang(r = {}) {
  const cand = (r.dil || "").toLowerCase();
  if (ALLOWED.includes(cand)) return cand;
  const has = (code) =>
    (code === "tr" ? r.baslik_tr : code === "en" ? r.baslik_en : r.baslik_de) &&
    (code === "tr" ? r.baslik_tr : code === "en" ? r.baslik_en : r.baslik_de) !== PLACEHOLDER;
  if (has("tr")) return "tr";
  if (has("en")) return "en";
  if (has("de")) return "de";
  return "tr";
}

function EtkinlikEditView() {
  const TT = useUiTexts();
  const notify = useNotify();
  const redirect = useRedirect();
  const { record, isLoading } = useEditContext();
  const [update, { isLoading: saving }] = useUpdate();

  const [form, setForm] = React.useState({
    baslik_tr: "",
    baslik_en: "",
    baslik_de: "",
    aciklama_tr: "",
    aciklama_en: "",
    aciklama_de: "",
    onceki_tr: "",
    onceki_en: "",
    onceki_de: "",
    resim: "",
    link: "",
    aktif: true,
    dil: "tr",
    tarih: "",
  });

  React.useEffect(() => {
    if (!isLoading && record) {
      const preferred = detectPreferredLang(record);
      setForm({
        baslik_tr: record.baslik_tr || "",
        baslik_en: record.baslik_en || "",
        baslik_de: record.baslik_de || "",
        aciklama_tr: record.aciklama_tr || "",
        aciklama_en: record.aciklama_en || "",
        aciklama_de: record.aciklama_de || "",
        onceki_tr: record.onceki_tr || "",
        onceki_en: record.onceki_en || "",
        onceki_de: record.onceki_de || "",
        resim: record.resim || "",
        link: record.link || "",
        aktif: !!record.aktif,
        dil: preferred, // 👈 düzenle açıldığında doğru dil
        tarih: (record.tarih && String(record.tarih).slice(0, 10)) || "",
      });
    }
  }, [isLoading, record]);

  const onChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!record) return;

    const merged = {
      ...record,
      ...form,
      aktif: !!form.aktif,
      dil: ALLOWED.includes(form.dil) ? form.dil : "tr",
      tarih: form.tarih ? new Date(form.tarih).toISOString().slice(0, 10) : record.tarih || "",
    };

    ["baslik_tr","baslik_en","baslik_de","aciklama_tr","aciklama_en","aciklama_de","onceki_tr","onceki_en","onceki_de"].forEach(
      (k) => {
        if (merged[k] === PLACEHOLDER) merged[k] = "";
      }
    );

    update(
      "etkinlikler",
      { id: record.id, data: merged, previousData: record },
      {
        onSuccess: () => {
          notify(TT.updatedOk, { type: "success" });
          redirect("/etkinlikler");
        },
        onError: (e) =>
          notify(`❌ Güncelleme hatası: ${e?.message || ""}`, {
            type: "warning",
          }),
      }
    );
  };

  if (isLoading || !record) {
    return <div className="p-6">Yükleniyor…</div>;
  }

  return (
    <>
      {/* Bildirimleri büyüt */}
      <GlobalStyles
        styles={{
          ".MuiSnackbarContent-message": { fontSize: "1.05rem", fontWeight: 800 },
          ".RaNotification-content": { fontSize: "1.05rem", fontWeight: 800 },
        }}
      />
      <div className="w-full">
        <form onSubmit={handleSubmit} className="w-full bg-white px-6 py-5">
          {/* iki sütunlu layout */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 16,
              alignItems: "start",
            }}
          >
            {/* Sol sütun */}
            <div className="space-y-4">
              {/* Başlık */}
              <div>
                <label className="block font-medium mb-1">{TT.title}</label>
                <input
                  name={`baslik_${form.dil}`}
                  value={form[`baslik_${form.dil}`] || ""}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, [`baslik_${form.dil}`]: e.target.value }))
                  }
                  className="w-full border rounded px-3 py-2"
                  required
                />
              </div>

              {/* Önceki etkinlik başlığı */}
              <div>
                <label className="block font-medium mb-1">{TT.previousTitle}</label>
                <input
                  name={`onceki_${form.dil}`}
                  value={form[`onceki_${form.dil}`] || ""}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, [`onceki_${form.dil}`]: e.target.value }))
                  }
                  className="w-full border rounded px-3 py-2"
                />
              </div>

              {/* Açıklama */}
              <div>
                <label className="block font-medium mb-1">
                  {TT.trDesc.replace("🇹🇷 ", "").replace(" (Türkçe)", "")}
                </label>
                <textarea
                  name={`aciklama_${form.dil}`}
                  value={form[`aciklama_${form.dil}`] || ""}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      [`aciklama_${form.dil}`]: e.target.value,
                    }))
                  }
                  className="w-full border rounded px-3 py-2"
                  rows={6}
                  required
                />
              </div>

              {/* Link */}
              <div>
                <label className="block font-medium mb-1">{TT.linkLbl}</label>
                <input
                  name="link"
                  value={form.link || ""}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-2"
                />
              </div>
            </div>

            {/* Sağ sütun */}
            <div className="space-y-4">
              {/* Resim */}
              <div>
                <label className="block font-medium mb-1">{TT.image}</label>
                <ResimUpload
                  label={TT.uploadImage}
                  onUpload={(url) => setForm((p) => ({ ...p, resim: url }))}
                />
                {form.resim && (
                  <img
                    src={form.resim}
                    alt="preview"
                    className="mt-2 h-24 w-24 object-cover rounded border"
                  />
                )}
              </div>

              {/* Tarih */}
              <div>
                <label className="block font-medium mb-1">{TT.date}</label>
                <input
                  type="date"
                  name="tarih"
                  value={form.tarih || ""}
                  onChange={(e) => setForm((p) => ({ ...p, tarih: e.target.value }))}
                  className="w-full border rounded px-3 py-2"
                />
              </div>

              {/* İçerik Dili */}
              <div>
                <label className="block font-medium mb-1">{TT.contentLangShort}</label>
                <select
                  name="dil"
                  value={form.dil}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="tr">{T.tr.langNames.tr}</option>
                  <option value="en">{T.tr.langNames.en}</option>
                  <option value="de">{T.tr.langNames.de}</option>
                </select>
              </div>

              {/* Kaydet/İptal */}
              <div className="pt-2 flex items-center gap-8">
                <button
                  type="button"
                  onClick={() => redirect("/etkinlikler")}
                  className="px-6 py-2 rounded text-white"
                  style={{ backgroundColor: "#f59e0b" }}
                >
                  {TT.cancel}
                </button>
                <button
                  type="submit"
                  disabled={saving}
                  className="px-6 py-2 rounded text-white disabled:opacity-60"
                  style={{ backgroundColor: "#2563eb" }}
                >
                  {saving ? TT.saving : TT.save}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

/* --- EtkinliklerCard: Create formu (iki sütun + tarih + önceki) --- */
const TK = {
  tr: {
    pageTitle: "Etkinlik Ekle",
    title: "Başlık",
    previousTitle: "Daha önceki etkinlik başlığı",
    image: "Resim",
    description: "Açıklama",
    link: "Link",
    contentLang: "İçerik Dili",
    status: "Durum",
    active: "Aktif",
    passive: "Pasif",
    save: "Kaydet",
    uploadImage: "📤 Görsel Yükle",
    savedOk: "✅ Etkinlik başarıyla eklendi",
    savedErr: "❌ Etkinlik eklenirken hata oluştu",
    date: "📅 Tarih",
    langNames: { tr: "Türkçe", en: "İngilizce", de: "Almanca" },
    placeholders: {
      title: { tr: "Türkçe başlık girin", en: "İngilizce başlık girin", de: "Almanca başlık girin" },
      desc: {
        tr: "Türkçe açıklama yazın",
        en: "İngilizce açıklama yazın",
        de: "Almanca açıklama yazın",
      },
    },
  },
  en: {
    pageTitle: "Add Event",
    title: "Title",
    previousTitle: "Previous event title",
    image: "Image",
    description: "Description",
    link: "Link",
    contentLang: "Content Language",
    status: "Status",
    active: "Active",
    passive: "Inactive",
    save: "Save",
    uploadImage: "📤 Upload Image",
    savedOk: "✅ Event added successfully",
    savedErr: "❌ Failed to add event",
    date: "📅 Date",
    langNames: { tr: "Turkish", en: "English", de: "German" },
    placeholders: {
      title: { tr: "Enter Turkish title", en: "Enter English title", de: "Enter German title" },
      desc: {
        tr: "Write description in Turkish",
        en: "Write description in English",
        de: "Write description in German",
      },
    },
  },
  de: {
    pageTitle: "Veranstaltung hinzufügen",
    title: "Titel",
    previousTitle: "Titel der früheren Veranstaltung",
    image: "Bild",
    description: "Beschreibung",
    link: "Link",
    contentLang: "Inhaltssprache",
    status: "Status",
    active: "Aktiv",
    passive: "Inaktiv",
    save: "Speichern",
    uploadImage: "📤 Bild hochladen",
    savedOk: "✅ Veranstaltung erfolgreich hinzugefügt",
    savedErr: "❌ Veranstaltung konnte nicht hinzugefügt werden",
    date: "📅 Datum",
    langNames: { tr: "Türkisch", en: "Englisch", de: "Deutsch" },
    placeholders: {
      title: { tr: "Türkischen Titel eingeben", en: "Englischen Titel eingeben", de: "Deutschen Titel eingeben" },
      desc: {
        tr: "Beschreibung auf Türkisch schreiben",
        en: "Beschreibung auf Englisch schreiben",
        de: "Beschreibung auf Deutsch schreiben",
      },
    },
  },
};

const EtkinliklerCard = () => {
  const [uiLang, setUiLang] = React.useState(
    () => (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase()
  );
  const TT = TK[ALLOWED.includes(uiLang) ? uiLang : "tr"];

  const [formData, setFormData] = React.useState({
    baslik_tr: "",
    baslik_en: "",
    baslik_de: "",
    aciklama_tr: "",
    aciklama_en: "",
    aciklama_de: "",
    onceki_tr: "",
    onceki_en: "",
    onceki_de: "",
    link: "https://",
    resim: "",
    durum: "Aktif",
    dil: "tr",
    tarih: new Date().toISOString().slice(0, 10),
  });

  const [aktifDiller, setAktifDiller] = React.useState(["tr", "en", "de"]);
  const notify = useNotify();
  const redirect = useRedirect();

  React.useEffect(() => {
    const applySettings = async () => {
      const appLang = (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase();
      setUiLang(ALLOWED.includes(appLang) ? appLang : "tr");

      let nextDil = ALLOWED.includes(appLang) ? appLang : "tr";
      let nextAktif = ["tr", "en", "de"];
      let apiDil = null;

      try {
        const token = localStorage.getItem("token");
        if (token) {
          const res = await fetch(`${API_BASE}/kurum-ayarlar`, {
  headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
});

          if (res.ok) {
            const json = await res.json();
            const d = json?.data || null;

            if (d) {
              let aktif = d.aktif_diller;
              if (typeof aktif === "string") {
                try {
                  aktif = JSON.parse(aktif);
                } catch {
                  aktif = ["tr", "en", "de"];
                }
              }
              if (Array.isArray(aktif) && aktif.length) {
                nextAktif = aktif.filter((x) => ALLOWED.includes(x));
              }
              const candidate = (d.dil || "").toLowerCase();
              apiDil = ALLOWED.includes(candidate) ? candidate : null;
            }
          }
        }
      } catch {}

      if (nextAktif.includes(appLang)) {
        nextDil = appLang;
      } else if (apiDil && nextAktif.includes(apiDil)) {
        nextDil = apiDil;
      } else {
        nextDil = nextAktif[0] || "tr";
      }

      setAktifDiller(nextAktif);
      setFormData((prev) => ({ ...prev, dil: nextDil }));
    };

    applySettings();

    const sync = () => applySettings();
    window.addEventListener("focus", sync);
    window.addEventListener("storage", sync);
    window.addEventListener("app_settings_change", sync);
    window.addEventListener("app_lang_change", sync);
    return () => {
      window.removeEventListener("focus", sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("app_settings_change", sync);
      window.removeEventListener("app_lang_change", sync);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const aktif = formData.durum === "Aktif";
    const placeholder = PLACEHOLDER;

    const etkinlik = {
      baslik_tr: formData.dil === "tr" ? formData.baslik_tr : placeholder,
      baslik_en: formData.dil === "en" ? formData.baslik_en : placeholder,
      baslik_de: formData.dil === "de" ? formData.baslik_de : placeholder,

      onceki_tr: formData.dil === "tr" ? formData.onceki_tr : placeholder,
      onceki_en: formData.dil === "en" ? formData.onceki_en : placeholder,
      onceki_de: formData.dil === "de" ? formData.onceki_de : placeholder,

      aciklama_tr: formData.dil === "tr" ? formData.aciklama_tr : placeholder,
      aciklama_en: formData.dil === "en" ? formData.aciklama_en : placeholder,
      aciklama_de: formData.dil === "de" ? formData.aciklama_de : placeholder,
      resim: formData.resim,
      link: formData.link,
      aktif,
      tarih: formData.tarih,
      dil: formData.dil,
    };

    try {
  const token = localStorage.getItem("token");   // << EKLENDİ

      const res = await fetch(`${API_BASE}/etkinlikler`, {
  method: "POST",
  headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  body: JSON.stringify(etkinlik),
});


      if (res.ok) {
        notify(TT.savedOk, { type: "success" });
        redirect("/etkinlikler");
      } else {
        notify(TT.savedErr, { type: "error" });
      }
    } catch (err) {
      console.error("Sunucu hatası:", err);
      notify(TT.savedErr, { type: "error" });
    }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  React.useEffect(() => {
    if (!aktifDiller.includes(formData.dil)) {
      setFormData((p) => ({ ...p, dil: aktifDiller[0] || "tr" }));
    }
  }, [aktifDiller, formData.dil]);

  const phTitle = TK[uiLang].placeholders.title[formData.dil];
  const phDesc = TK[uiLang].placeholders.desc[formData.dil];

  return (
    <>
      {/* Bildirimleri büyüt */}
      <GlobalStyles
        styles={{
          ".MuiSnackbarContent-message": { fontSize: "1.05rem", fontWeight: 800 },
          ".RaNotification-content": { fontSize: "1.05rem", fontWeight: 800 },
        }}
      />
      <div className="p-6 w/full bg-white rounded shadow ml-0">
        <h2 className="text-xl font-semibold mb-4">{TT.pageTitle}</h2>

        {/* iki sütunlu layout */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 16,
              alignItems: "start",
            }}
          >
            {/* Sol sütun */}
            <div className="space-y-4">
              {/* Başlık */}
              <div>
                <label className="block font-medium mb-1">{TT.title}</label>
                <input
                  name={`baslik_${formData.dil}`}
                  value={formData[`baslik_${formData.dil}`] || ""}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  placeholder={phTitle}
                  required
                />
              </div>

              {/* Önceki etkinlik */}
              <div>
                <label className="block font-medium mb-1">{TT.previousTitle}</label>
                <input
                  name={`onceki_${formData.dil}`}
                  value={formData[`onceki_${formData.dil}`] || ""}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
              </div>

              {/* Açıklama */}
              <div>
                <label className="block font-medium mb-1">{TT.description}</label>
                <textarea
                  name={`aciklama_${formData.dil}`}
                  value={formData[`aciklama_${formData.dil}`] || ""}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  rows={6}
                  placeholder={phDesc}
                  required
                />
              </div>

              {/* Link */}
              <div>
                <label className="block font-medium mb-1">{TT.link}</label>
                <input
                  name="link"
                  value={formData.link}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
              </div>
            </div>

            {/* Sağ sütun */}
            <div className="space-y-4">
              {/* Resim */}
              <div>
                <label className="block font-medium mb-1">{TT.image}</label>
                <ResimUpload
                  onUpload={(url) => setFormData({ ...formData, resim: url })}
                  defaultPreview={formData.resim}
                  label={TT.uploadImage}
                />
              </div>

              {/* Tarih */}
              <div>
                <label className="block font-medium mb-1">{TT.date}</label>
                <input
                  type="date"
                  name="tarih"
                  value={formData.tarih}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
              </div>

              {/* İçerik Dili */}
              <div>
                <label className="block font-medium mb-1">{TT.contentLang}</label>
                <select
                  name="dil"
                  value={formData.dil}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                >
                  {aktifDiller.includes("tr") && <option value="tr">{TT.langNames.tr}</option>}
                  {aktifDiller.includes("en") && <option value="en">{TT.langNames.en}</option>}
                  {aktifDiller.includes("de") && <option value="de">{TT.langNames.de}</option>}
                </select>
              </div>

              {/* Durum */}
              <div>
                <label className="block font-medium mb-1">{TT.status}</label>
                <select
                  name="durum"
                  value={formData.durum}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="Aktif">{TT.active}</option>
                  <option value="Pasif">{TT.passive}</option>
                </select>
              </div>

              {/* Kaydet */}
              <div className="pt-2">
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
                >
                  {TT.save}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

// RA Resource için create bileşeni
export const EtkinlikCreate = () => <EtkinliklerCard />;
